import { myAccount, myaccount } from '@/api/index'
// export function getInterval (data, params) {
//   const extendUrl = params.urlParam ? '?' + params.urlParam : ''
//   return publicData.request({
//     method: 'post',
//     url: '/Getinterval' + extendUrl
//   })
// }

export function get_web_account_77335 (data) {
  return myAccount.request({
    method: 'post',
    url: '/get_web_account_77335',
    data
  })
}
export function deleteAccountInfo_77335 (data) {
  return myAccount.request({
    method: 'post',
    url: '/DeleteAccountInfo_77335',
    data
  })
}
export function get_MyAccountInfo_77335 (data) {
  return myaccount.request({
    method: 'post',
    url: '/get_MyAccountInfo_77335',
    data
  })
}
export function addWebAccount_77335 (data) {
  return myaccount.request({
    method: 'post',
    url: '/AddWebAccount_77335',
    data
  })
}
export function addWebAccountCZ_77335 (data) {
  return myaccount.request({
    method: 'post',
    url: '/AddWebAccountCZ_77335',
    data
  })
}
export function addWebAccountSH_77335 (data) {
  return myaccount.request({
    method: 'post',
    url: '/AddWebAccountSH_77335',
    data
  })
}
export function deleteWebAccountCZ (data) {
  return myaccount.request({
    method: 'post',
    url: '/deleteWebAccountCZ',
    data
  })
}
export function Addaccbili_82838 (data) {
  return myaccount.request({
    method: 'post',
    url: '/Addaccbili_82838',
    data
  })
}
export function getRemainWeb_77335 (data) {
  return myAccount.request({
    method: 'post',
    url: '/GetRemainWeb_77335',
    data
  })
}
export function get_web_account_cz_77335 (data) {
  return myAccount.request({
    method: 'post',
    url: '/get_web_account_cz_77335',
    data
  })
}
export function get_web_order_77335 (data) {
  return myAccount.request({
    method: 'post',
    url: '/get_web_order_77335',
    data
  })
}
export function get_accbili_byid (data) {
  return myaccount.request({
    method: 'post',
    url: '/get_accbili_byid',
    data
  })
}
export function InitkaihuTemplateData_86308 (data) {
  return myAccount.request({
    method: 'post',
    url: '/InitkaihuTemplateData_86308',
    data
  })
}
export function Savejskh_86308 (data) {
  return myAccount.request({
    method: 'post',
    url: '/Savejskh_86308',
    data
  })
}

export function ImportAccountChanageDetails (data) {
  return myAccount.request({
    method: 'post',
    url: '/ImportAccountChanageDetails',
    data
  })
}

// export function checkOutexcel (data) {
//   return publicData.request({
//     method: 'post',
//     url: '/checkOutexcel',
//     data,
//     iSFromData: true
//   })
// }
export function DeleteDeliveryCharge4 (data: any) {
  return myAccount.request({
    method: 'post',
    url: '/DeleteDeliveryCharge4',
    data
    // iSFromData: true
  })
}

export function mySaveDeliveryData (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/SaveDeliveryData' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveRatio_77335 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/SaveRatio_77335' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveOutacc_77335 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/SaveOutacc_77335' + extendUrl,
    data,
    iSFromData: true
  })
}
export function Savejsbili_80799 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/Savejsbili_80799' + extendUrl,
    data,
    iSFromData: true
  })
}

export function Savejsbili_71316 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/Savejsbili_71316' + extendUrl,
    data,
    iSFromData: true
  })
}

export function Savejsbili_99128 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/Savejsbili_99128' + extendUrl,
    data,
    iSFromData: true
  })
}
export function Savejsbili_82838 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/Savejsbili_82838' + extendUrl,
    data,
    iSFromData: true
  })
}
export function Savejsbili_86308 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/Savejsbili_86308' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveRatio_82233 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/SaveRatio_82233' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveOutacc_82233 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/SaveOutacc_82233' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveDeliveryData82233 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/SaveDeliveryData82233' + extendUrl,
    data,
    iSFromData: true
  })
}
export function GetRatiotypeCom (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/GetRatiotypeCom' + extendUrl,
    iSFromData: true
  })
}

export function SaveEditPrice_77335 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/SaveEditPrice_77335' + extendUrl,
    iSFromData: true,
    data
  })
}
export function SaveEditPrice_82233 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/SaveEditPrice_82233' + extendUrl,
    iSFromData: true,
    data
  })
}
export function SaveEditjsbili_80799 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/SaveEditjsbili_80799' + extendUrl,
    iSFromData: true,
    data
  })
}
export function SaveEditjsbili_86308 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return myAccount.request({
    method: 'post',
    url: '/SaveEditjsbili_86308' + extendUrl,
    iSFromData: true,
    data
  })
}
